<a class="user-label" [routerLink]="['/user/' + user.id]">
  <div class="ui no-bg large label">
    <span class="username">{{user.osu_username || user.name }}</span>
    <i class="fitted star icon" [class.yellow]="user.stars">
    </i>
    <span class="text-small"> {{ user.stars }}</span>
  </div>
</a>
